/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdDomainSettingsUnityOptionsDistributionOptions, FxIdDomainSettingsUnityOptionsDistributionOptionsFromJSONTyped, FxIdDomainSettingsUnityOptionsDistributionOptionsToJSON, } from './FxIdDomainSettingsUnityOptionsDistributionOptions';
export function FxIdDomainSettingsUnityOptionsDistributionFromJSON(json) {
    return FxIdDomainSettingsUnityOptionsDistributionFromJSONTyped(json, false);
}
export function FxIdDomainSettingsUnityOptionsDistributionFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdDomainSettingsUnityOptionsDistributionOptions(json)) {
        return FxIdDomainSettingsUnityOptionsDistributionOptionsFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdDomainSettingsUnityOptionsDistributionToJSON(json) {
    return FxIdDomainSettingsUnityOptionsDistributionToJSONTyped(json, false);
}
export function FxIdDomainSettingsUnityOptionsDistributionToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdDomainSettingsUnityOptionsDistributionOptions(value)) {
        return FxIdDomainSettingsUnityOptionsDistributionOptionsToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdDomainSettingsUnityOptionsDistribution.js.map